import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {PatronAddress} from '@store/patron/patron.types';
import {TruncateDirective} from '@aviary/directives/truncate.directive';

@Component({
  selector: 'px-patron-address-display',
  template: `
    <div class="flex flex-col">
      <p mxTruncate class="text-title-large">{{ selectors.addressTypeWithPrimaryLabelFor(address) | select }}</p>
      <p mxTruncate [mxTruncateMaxLines]="2" class="text-body-large text-on-surface-variant">{{ selectors.addressLine1And2For(address) | select }}</p>
      <p mxTruncate [mxTruncateMaxLines]="2" class="text-body-large text-on-surface-variant">{{ selectors.cityStateZipFor(address) | select }}</p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, TruncateDirective]
})
export class PatronAddressDisplayComponent {
  @Input({required: true}) public address: PatronAddress;
  public readonly selectors = PatronSelectors.AddressStateless;
}
